import React from "react";
import { EvidenceRef } from "../../../types/healthcare/PatientAnalysisTypes";

/**
 * Cross-component UI state for evidence references. Lets the shared EvidenceRefList
 * make a reference clickable (to open the original record's detail modal) without
 * prop-drilling an onRefClick handler through every renderer that displays refs.
 *
 * When no provider is mounted (or `onRefClick` is undefined), EvidenceRefList renders
 * references as plain, non-interactive text exactly as before.
 */
export interface EvidenceRefInteraction {
	onRefClick?: (ref: EvidenceRef) => void;
}

export const EvidenceRefInteractionContext = React.createContext<EvidenceRefInteraction>({});

export default EvidenceRefInteractionContext;
